<template>
<div id="panel-right">
    <span>Panel Left</span>
</div>        
</template>

<script>
export default {
    name: 'PanelLeft'
}
</script>

<style>
#panel-right{
    height: 100%;
    background-color: #d9d9d9;
    border-left: 1px #dcdee2 solid;
}
</style>



// WEBPACK FOOTER //
// src/components/PanelRight.vue